// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".left-column[data-v-2dbc7c44]{width:100%;max-width:750px;margin-right:30px}.field[data-v-2dbc7c44],.left-column[data-v-2dbc7c44]{display:flex;flex-direction:column}.field[data-v-2dbc7c44]{margin-top:20px}.label[data-v-2dbc7c44]{color:#000;font-weight:600;line-height:1.21429rem;margin-bottom:5px}.--error[data-v-2dbc7c44]  .inner-input{border:2px solid #ff5757!important}", ""]);
// Exports
module.exports = exports;
